// VerifyEmail.tsx
import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "wouter";
import axios from "axios";
import API_URL from "@/config";
import { useDispatch } from "react-redux";
import { login } from "@/Redux/authSlice";
import { useToast } from "@/hooks/use-toast";

export default function VerifyEmail() {
    const dispatch = useDispatch();
    const { toast } = useToast();
    const { token } = useParams();
    const [, setLocation] = useLocation();
    const [status, setStatus] = useState<"loading" | "success" | "error">(
        "loading"
    );
    const [message, setMessage] = useState("");

    console.log(token)

    useEffect(() => {
        if (token) {
            axios
                .get(`${API_URL}/api/auth/verify-email/${token}`)
                .then((res) => {
                    if (res.data?.success) {
                        setStatus("success");
                        setMessage("Email verified successfully!");
                        sessionStorage.setItem("user", JSON.stringify(res?.data?.user));
                        sessionStorage.setItem("token", res?.data?.token);
                        dispatch(login({ user: res?.data?.user, token: res?.data?.token }));
                        toast({
                            title: "Account verified successfully!",
                            description: "Redirecting to dashboard...",
                        });
                        setTimeout(() => {
                            setLocation("/");
                        },2000)

                    }
                })
                .catch((err) => {
                    setStatus("error");
                    setMessage(
                        err.response?.data?.message || "Invalid or expired verification link."
                    );
                });
        }
    }, [token]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            {status === "loading" && <p>Verifying your email...</p>}
            {status === "success" && (
                <p className="text-green-600 font-semibold">{message}</p>
            )}
            {status === "error" && (
                <p className="text-red-600 font-semibold">{message}</p>
            )}
        </div>
    );
}
